/* Barevya — home page interactivity. Vanilla JS, no dependencies. */
(function () {
  var B = window.Barevya || (window.Barevya = {});
  var routes = B.routes || { cart_add: '/cart/add.js', cart_change: '/cart/change.js', cart: '/cart.js' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fmt = function (cents) { return '€' + (cents / 100).toFixed(2).replace('.00', ''); };

  /* ---------- Shade catalogue (injected by quiz section, with fallback) ---------- */
  var SHADES = B.shades || [
    { name: 'Porcelain', hex: '#F1D8C4' }, { name: 'Ivory', hex: '#EBC9AE' },
    { name: 'Light', hex: '#E3B896' }, { name: 'Beige', hex: '#D8A87F' },
    { name: 'Natural', hex: '#CB9468' }, { name: 'Golden', hex: '#BC8153' },
    { name: 'Tan', hex: '#A96C43' }, { name: 'Caramel', hex: '#925736' },
    { name: 'Deep', hex: '#74422A' }, { name: 'Espresso', hex: '#55301E' }
  ];
  /* Italian PDP feature copy. On the Italian locale the store's translation
     layer strips the product section's own injected copy (and re-renders it in
     English), so we keep an immune copy here in the global asset. The product
     section still provides B.pdpFeat on locales where it survives (e.g. /en). */
  if (!B.pdpFeat) B.pdpFeat = [
    { kicker: "01 · Una pelle che sembra pelle", title: "Copri ciò che vuoi, resta te stessa.", body: "La texture flessibile e leggera si sfuma facilmente e uniforma l’aspetto della pelle — curato e naturale, mai pesante o effetto maschera.", steps: "" },
    { kicker: "02 · Coprenza modulabile", title: "Copre più delle semplici imperfezioni.", body: "Attenua l’aspetto di capillari, cicatrici, tatuaggi, pigmentazioni e tono non uniforme — con una coprenza modulabile che resta confortevole.", steps: "" },
    { kicker: "03 · Resistente ad acqua e sudore", title: "Fatto per il caldo, il sudore e le giornate lunghe.", body: "Resiste ad acqua e sudore, aiuta a prevenire le sbavature e mantiene la pelle uniforme — fino a 48 ore di tenuta senza continui ritocchi.", steps: "" },
    { kicker: "04 · Sicurezza", title: "Torna a indossare ciò che vuoi.", body: "Abiti, shorts, costumi, look di tutti i giorni — senza pianificare in base a ciò che vuoi nascondere. Più libertà, meno imbarazzo.", steps: "" },
    { kicker: "05 · Dieci tonalità", title: "Trova la tua corrispondenza perfetta.", body: "Dieci tonalità dal chiaro all’intenso per scegliere il tono più vicino alla tua pelle naturale, per un finish morbido e armonioso.", steps: "" },
    { kicker: "06 · In meno di un minuto", title: "Applicazione semplice in 3 passi.", body: "Un minuto al mattino, coperta finché non scegli di rimuoverla.", steps: "Applica una piccola quantità su pelle pulita e asciutta.|Sfuma in modo uniforme con le dita, un pennello o una spugnetta.|Lascia fissare qualche istante prima di vestirti per un finish più liscio e anti-trasferimento." }
  ];
  /* Italian text restorations for the it-locale, where the store's translation
     layer serves English for these exact strings. Client-set text is immune. */
  B.itMap = B.itMap || {
    "Free shipping and VAT included · 40,000 satisfied customers": "Spedizione gratuita e IVA inclusa · 40.000 clienti soddisfatti",
    "Find Your Shade": "Trova la tua tonalità",
    "Standard price": "Prezzo standard",
    "MOST CHOSEN": "IL PIÙ SCELTO",
    "3-month supply": "Scorta per 3 mesi",
    "Supply for 6 months": "Scorta per 6 mesi",
    "in the tone of": "nella tua tonalità",
    "01 · Leather that looks like leather": "01 · Una pelle che sembra pelle",
    "Cover what you want, remain yourself.": "Copri ciò che vuoi, resta te stessa.",
    "The flexible, lightweight texture blends easily and evens out skin tone—groomed and natural, never heavy or mask-like.": "La texture flessibile e leggera si sfuma facilmente e uniforma l’aspetto della pelle — curato e naturale, mai pesante o effetto maschera.",
    "02 · Modulable coverage": "02 · Coprenza modulabile",
    "It covers more than just imperfections.": "Copre più delle semplici imperfezioni.",
    "Reduce the appearance of spider veins, scars, tattoos, hyperpigmentation and uneven tone—with buildable coverage that feels comfortable.": "Attenua l’aspetto di capillari, cicatrici, tatuaggi, pigmentazioni e tono non uniforme — con una coprenza modulabile che resta confortevole.",
    "03 · Resistant to water and sweat": "03 · Resistente ad acqua e sudore",
    "Made for heat, sweat and long days.": "Fatto per il caldo, il sudore e le giornate lunghe.",
    "04 · Security": "04 · Sicurezza",
    "Go back to wearing what you want.": "Torna a indossare ciò che vuoi.",
    "Dresses, shorts, swimsuits, everyday looks — without planning around what you want to hide. More freedom, less embarrassment.": "Abiti, shorts, costumi, look di tutti i giorni — senza pianificare in base a ciò che vuoi nascondere. Più libertà, meno imbarazzo.",
    "05 · Ten Shades": "05 · Dieci tonalità",
    "Find your perfect match.": "Trova la tua corrispondenza perfetta.",
    "Ten shades from light to intense to choose the tone closest to your natural skin, for a soft and harmonious finish.": "Dieci tonalità dal chiaro all’intenso per scegliere il tono più vicino alla tua pelle naturale, per un finish morbido e armonioso.",
    "06 · In under a minute": "06 · In meno di un minuto",
    "Simple 3-step application.": "Applicazione semplice in 3 passi.",
    "One minute in the morning, covered until you choose to remove it.": "Un minuto al mattino, coperta finché non scegli di rimuoverla.",
    "Apply a small amount to clean, dry skin.": "Applica una piccola quantità su pelle pulita e asciutta.",
    "Blend evenly with your fingers, a brush, or a sponge.": "Sfuma in modo uniforme con le dita, un pennello o una spugnetta.",
    "Allow to set for a few moments before dressing for a smoother, transfer-proof finish.": "Lascia fissare qualche istante prima di vestirti per un finish più liscio e anti-trasferimento.",
    "What people are saying": "Cosa dicono le persone",
    "“Finally, something that matches my skin and truly stays in place at the beach.”": "“Finalmente qualcosa che si abbina alla mia pelle e resta davvero al suo posto in spiaggia.”",
    "“The shade matcher got it on the first try. It looks like my skin.”": "“Il trova-tonalità ha indovinato al primo tentativo. Sembra la mia pelle.”",
    "“Sure in a bikini for the first time in years. It doesn't even move in the water.”": "“Sicura in bikini per la prima volta dopo anni. Non si muove nemmeno in acqua.”",
    "Florence": "Firenze",
    "Find Key": "Trova Tonalità",
    "Buy the ritual": "Acquista il rituale",
    "Rituals, news and 15% off your first order.": "Rituali, novità e il 15% di sconto sul primo ordine.",
    "Free shipping and VAT included · 30-day warranty": "Spedizione gratuita e IVA inclusa · Garanzia 30 giorni"
  };

  var VARIANTS = B.variants || {}; // { "Natural": 1234567890, ... }
  var VARIANTHEX = B.variantHex || {}; // { "123456789": "#74422A", ... } keyed by variant id
  var hexOf = function (name) { for (var i = 0; i < SHADES.length; i++) if (SHADES[i].name === name) return SHADES[i].hex; return '#CB9468'; };
  var idOf = function (name) { for (var i = 0; i < SHADES.length; i++) if (SHADES[i].name === name) return SHADES[i].id; return null; };

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = $('#bx-toast'); if (!t) return;
    t.querySelector('.bx-toast__msg').textContent = msg;
    t.classList.add('is-open');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-open'); }, 2400);
  }

  /* ---------- Tone game slider ---------- */
  function initTone() {
    var el = $('#bx-tone'); if (!el) return;
    var range = $('.bx-range', el), divider = $('.bx-tone__divider', el), dot = $('.bx-tone__dot', el);
    var dotBig = $('#bx-tone-swatch'), code = $('#bx-tone-code'), name = $('#bx-tone-name'), cta = $('#bx-tone-cta');
    function update() {
      var v = +range.value, idx = Math.round((v / 100) * (SHADES.length - 1)), s = SHADES[idx];
      divider.style.left = v + '%'; dot.style.left = v + '%'; dot.style.background = s.hex;
      if (dotBig) dotBig.style.background = s.hex;
      if (code) code.textContent = (idx + 1) + 'N';
      if (name) name.textContent = s.name;
      if (cta) cta.textContent = 'Affina la mia tonalità — ' + (idx + 1) + 'N';
    }
    range.addEventListener('input', update); update();
  }

  /* ---------- Before / after sliders ---------- */
  function initBA() {
    $$('.bx-ba').forEach(function (ba) {
      var range = $('.bx-range', ba), after = $('.bx-ba__after', ba), line = $('.bx-ba__line', ba), grip = $('.bx-ba__grip', ba);
      function update() {
        var v = +range.value;
        after.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
        line.style.left = v + '%'; grip.style.left = v + '%';
      }
      range.addEventListener('input', update); update();
    });
  }

  /* ---------- Cart drawer ---------- */
  function openDrawer() { $('#bx-drawer').classList.add('is-open'); $('#bx-scrim').classList.add('is-open'); }
  function closeDrawer() { $('#bx-drawer').classList.remove('is-open'); if (!anyModalOpen()) $('#bx-scrim').classList.remove('is-open'); }

  function renderCart(cart) {
    var count = cart.item_count;
    $$('.bx-bag__count').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
    var wrap = $('#bx-drawer'); if (!wrap) return;
    $('#bx-drawer-count').textContent = count;
    var itemsBox = $('#bx-drawer-items'), foot = $('#bx-drawer-foot'), empty = $('#bx-drawer-empty');
    if (count === 0) { itemsBox.hidden = true; foot.hidden = true; empty.hidden = false; return; }
    empty.hidden = true; itemsBox.hidden = false; foot.hidden = false;

    // Shipping is free by default
    var free = true;
    var progress = '<div class="bx-note bx-note--win">🎁 Spedizione gratuita inclusa</div>';

    var rows = cart.items.map(function (it) {
      var shade = (it.options_with_values && it.options_with_values[0]) ? it.options_with_values[0].value : (it.variant_title || '');
      var sw = (it.variant_id != null && VARIANTHEX[it.variant_id]) || hexOf(shade);
      return '' +
        '<div class="bx-line">' +
          '<div class="bx-line__img" style="background:' + sw + '"><span style="font-size:10px;color:rgba(255,255,255,.85);font-weight:600">' + shade + '</span></div>' +
          '<div style="flex:1">' +
            '<div style="display:flex;justify-content:space-between;gap:10px"><span style="font-weight:600;font-size:15px">' + it.product_title + '</span><span style="font-weight:700;font-size:15px">' + fmt(it.final_line_price) + '</span></div>' +
            (shade ? '<div style="font-size:12.5px;color:var(--muted2);margin-top:2px">Tonalità · ' + shade + '</div>' : '') +
            '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:12px">' +
              '<div class="bx-qty"><button data-key="' + it.key + '" data-to="' + (it.quantity - 1) + '">–</button><span style="min-width:20px;text-align:center;font-size:13px;font-weight:600">' + it.quantity + '</span><button data-key="' + it.key + '" data-to="' + (it.quantity + 1) + '">+</button></div>' +
              '<button data-key="' + it.key + '" data-to="0" style="font-size:12.5px;color:var(--muted2);text-decoration:underline">Rimuovi</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    itemsBox.innerHTML = progress + rows;
    $('#bx-subtotal').textContent = fmt(cart.total_price);
    $('#bx-ship').textContent = free ? 'Gratis' : '€4.90';
    $('#bx-total').textContent = fmt(cart.total_price + (free ? 0 : 490));

    $$('.bx-qty button, [data-to]', itemsBox).forEach(function (btn) {
      btn.addEventListener('click', function () { changeLine(btn.getAttribute('data-key'), +btn.getAttribute('data-to')); });
    });
  }

  function fetchCart() { fetch(routes.cart).then(function (r) { return r.json(); }).then(renderCart); }

  function changeLine(key, qty) {
    fetch(routes.cart_change, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(variantId, qty, shade, cb) {
    if (!variantId) { toast('Collega una variante prodotto per la tonalità ' + shade); if (cb) cb(); return; }
    fetch(routes.cart_add, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      fetchCart(); toast('Skin Perfector™ aggiunto al carrello'); openDrawer(); if (cb) cb();
    });
  }

  // Add several line items in one request: items = [{ id, quantity }, ...]
  function addItems(items, msg, cb) {
    items = (items || []).filter(function (i) { return i && i.id; });
    if (!items.length) { toast('Collega il prodotto per aggiungere questa confezione'); if (cb) cb(); return; }
    fetch(routes.cart_add, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function () {
      fetchCart(); toast(msg || 'Aggiunto al carrello'); openDrawer(); if (cb) cb();
    });
  }

  // expose a small cart API for standalone sections (e.g. bundle tiers)
  B.cart = { add: addToCart, addItems: addItems, open: openDrawer, refresh: fetchCart, toast: toast };

  /* ---------- Quiz ---------- */
  var QUIZ = [
    { id: 'tone', q: 'Come descriveresti il tono della tua pelle?', opts: [
      { v: 'fair', label: 'Chiara', sub: 'Si scotta facilmente', hex: '#EBC9AE' }, { v: 'light', label: 'Chiara-media', sub: 'A volte si abbronza', hex: '#D8A87F' },
      { v: 'medium', label: 'Media', sub: 'Si abbronza facilmente', hex: '#BC8153' }, { v: 'deep', label: 'Scura', sub: 'Si scotta raramente', hex: '#74422A' } ] },
    { id: 'undertone', q: 'Qual è il tuo sottotono?', opts: [
      { v: 'cool', label: 'Freddo', sub: 'Rosa / blu' }, { v: 'neutral', label: 'Neutro', sub: 'Bilanciato' },
      { v: 'warm', label: 'Caldo', sub: 'Dorato / oliva' }, { v: 'unsure', label: 'Non so', sub: 'Scegli tu' } ] },
    { id: 'covering', q: 'Cosa vuoi coprire principalmente?', opts: [
      { v: 'tattoo', label: 'Tatuaggi' }, { v: 'scar', label: 'Cicatrici' }, { v: 'spots', label: 'Vene e macchie' }, { v: 'stretch', label: 'Smagliature' } ] },
    { id: 'coverage', q: 'Quanta coprenza desideri?', opts: [
      { v: 'natural', label: 'Naturale', sub: 'Sfuma e uniforma' }, { v: 'medium', label: 'Media', sub: 'Ogni giorno' }, { v: 'full', label: 'Totale', sub: 'Copertura completa' } ] }
  ];
  var qStep = 0, qAns = {}, qResult = null;

  function computeShade() {
    var base = { fair: 1, light: 3, medium: 5, deep: 8 }[qAns.tone]; if (base == null) base = 4;
    var idx = base;
    if (qAns.undertone === 'cool') idx -= 1;
    if (qAns.undertone === 'warm') idx += 1;
    idx = Math.max(0, Math.min(SHADES.length - 1, idx));
    var s = SHADES[idx];
    var cover = { natural: 'un finish naturale e sfumato', medium: 'una coprenza media da tutti i giorni', full: 'una copertura totale' }[qAns.coverage] || 'un finish naturale';
    var utMap = { cool: 'freddo', neutral: 'neutro', warm: 'caldo' }; var ut = qAns.undertone === 'unsure' ? 'tono della pelle' : ('sottotono ' + (utMap[qAns.undertone] || '')); var blurb = 'In base al tuo ' + ut + ', "' + s.name + '" si fonde con la tua pelle per ' + cover + '.';
    return { name: s.name, hex: s.hex, id: s.id, blurb: blurb };
  }

  function renderQuiz() {
    var modal = $('#bx-quiz'); if (!modal) return;
    var body = $('#bx-quiz-body'), result = $('#bx-quiz-result'), fill = $('#bx-quiz-fill');
    if (qResult) {
      body.hidden = true; result.hidden = false; fill.style.width = '100%';
      $('#bx-result-dot').style.background = qResult.hex;
      $('#bx-result-name').textContent = qResult.name;
      $('#bx-result-blurb').textContent = qResult.blurb;
      $('#bx-result-add').textContent = 'Aggiungi Skin Perfector™ in ' + qResult.name + ' — €39';
      return;
    }
    body.hidden = false; result.hidden = true;
    var q = QUIZ[qStep];
    fill.style.width = (qStep / QUIZ.length * 100) + '%';
    $('#bx-quiz-step').textContent = 'Passo ' + (qStep + 1) + ' di ' + QUIZ.length + ' · Sblocca il 25% di sconto';
    $('#bx-quiz-title').textContent = q.q;
    $('#bx-quiz-back').style.display = qStep > 0 ? '' : 'none';
    var opts = $('#bx-quiz-opts');
    opts.innerHTML = q.opts.map(function (o) {
      return '<button class="bx-opt" data-v="' + o.v + '">' +
        (o.hex ? '<span class="bx-opt__sw" style="background:' + o.hex + '"></span>' : '') +
        '<span><span style="display:block;font-size:15px;font-weight:600">' + o.label + '</span>' +
        (o.sub ? '<span style="font-size:12.5px;color:var(--muted2)">' + o.sub + '</span>' : '') + '</span></button>';
    }).join('');
    $$('.bx-opt', opts).forEach(function (btn) {
      btn.addEventListener('click', function () { pick(q.id, btn.getAttribute('data-v')); });
    });
  }

  function pick(id, v) {
    qAns[id] = v;
    if (qStep < QUIZ.length - 1) { qStep++; } else { qResult = computeShade(); try { localStorage.setItem('bx_shade', qResult.name); } catch (e) {} }
    renderQuiz();
  }
  function openQuiz() { qStep = 0; qAns = {}; qResult = null; renderQuiz(); $('#bx-quiz').classList.add('is-open'); $('#bx-scrim').classList.add('is-open'); }
  function closeQuiz() { $('#bx-quiz').classList.remove('is-open'); if (!anyModalOpen()) $('#bx-scrim').classList.remove('is-open'); }
  function anyModalOpen() { return $('#bx-quiz').classList.contains('is-open') || $('#bx-drawer').classList.contains('is-open'); }

  /* ---------- Wire up ---------- */
  /* ---------- Locale text fixups ----------------------------------------
     The store's primary (Italian) locale has a few translation overrides
     saved against theme sections that serve English/wrong text (announcement
     bar, "Find Your Shade" nav label, lowercase logo). Those overrides live in
     the shop's translation database and can't be changed from theme files, but
     they only touch server-rendered content — client-side text set here is
     immune (same reason the "Carrello" label is always correct). We only
     correct the Italian locale so the English (/en) storefront is untouched. */
  // Walk every text node and swap known English strings for their Italian.
  function retranslate(rootEl) {
    if (!('createTreeWalker' in document)) return;
    var tw = document.createTreeWalker(rootEl || document.body, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = tw.nextNode())) {
      var raw = node.nodeValue; if (!raw) continue;
      var t = raw.trim(); if (!t) continue;
      if (Object.prototype.hasOwnProperty.call(B.itMap, t)) {
        node.nodeValue = raw.replace(t, B.itMap[t]);
      }
    }
  }

  function initLocaleFix() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang.indexOf('it') !== 0) return;
    retranslate(document.body);
    var ann = document.querySelector('.bx-announce');
    if (ann) ann.textContent = 'Spedizione gratuita e IVA inclusa · 40.000 clienti soddisfatti';
    // Generic: any element carrying the correct Italian in data-bx-it gets it restored.
    $$('[data-bx-it]').forEach(function (el) {
      var v = el.getAttribute('data-bx-it');
      if (v != null && v !== '' && el.textContent !== v) el.textContent = v;
    });
    $$('.bx-nav a[data-bx-open-quiz], #bx-mobmenu a[data-bx-open-quiz]').forEach(function (a) {
      var t = (a.textContent || '').trim();
      if (t === 'Find Your Shade' || t === 'Find your shade' || t === 'Trova Tonalità') {
        a.textContent = 'Trova la tua tonalità';
      }
    });
    // Footer brand (translation layer mangles the wordmark to "Brava")
    var flogo = document.querySelector('.bx-footer__logo');
    if (flogo) flogo.textContent = 'BAREVYA';
    var fcopy = document.querySelector('.bx-footer__bar span');
    if (fcopy) fcopy.textContent = '© 2026 BAREVYA™';
    // PDP feature blocks: restore Italian source stashed in a <script> (immune to the override).
    if (B.pdpFeat && B.pdpFeat.length) {
      $$('.bx-feature').forEach(function (fe, i) {
        var d = B.pdpFeat[i]; if (!d) return;
        var k = fe.querySelector('.bx-eyebrow'); if (k && d.kicker) k.textContent = d.kicker;
        var t = fe.querySelector('h3.bx-serif'); if (t && d.title) t.textContent = d.title;
        var b = fe.querySelector('p.bx-muted'); if (b && d.body) b.textContent = d.body;
        if (d.steps) {
          var st = d.steps.split('|');
          $$('.bx-feature__steps li > span:last-child', fe).forEach(function (sp, j) {
            if (st[j]) sp.textContent = st[j].trim();
          });
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLocaleFix(); initTone(); initBA(); fetchCart();

    $$('[data-bx-open-quiz]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeMobMenu(); openQuiz(); }); });
    $$('[data-bx-open-cart]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeMobMenu(); openDrawer(); }); });

    var burger = $('#bx-burger'), header = $('.bx-header');
    function closeMobMenu() { if (header) header.classList.remove('is-menu-open'); if (burger) { burger.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); } }
    if (burger && header) {
      burger.addEventListener('click', function () {
        var open = header.classList.toggle('is-menu-open');
        burger.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      $$('#bx-mobmenu a:not([data-bx-open-quiz])').forEach(function (a) { a.addEventListener('click', closeMobMenu); });
    }
    $('#bx-quiz-close') && $('#bx-quiz-close').addEventListener('click', closeQuiz);
    $('#bx-quiz-back') && $('#bx-quiz-back').addEventListener('click', function () { if (qStep > 0) { qStep--; renderQuiz(); } });
    $('#bx-quiz-retake') && $('#bx-quiz-retake').addEventListener('click', function () { qStep = 0; qAns = {}; qResult = null; renderQuiz(); });
    $('#bx-result-add') && $('#bx-result-add').addEventListener('click', function () {
      var name = qResult.name; addToCart(qResult.id || VARIANTS[name], 1, name, function () { closeQuiz(); });
    });
    $('#bx-drawer-close') && $('#bx-drawer-close').addEventListener('click', closeDrawer);
    $('#bx-scrim') && $('#bx-scrim').addEventListener('click', function () { closeQuiz(); closeDrawer(); });

    // Any product add button (shop / bundle / add-on): <button data-bx-add data-variant="{{variant.id}}" data-shade="Natural">
    $$('[data-bx-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        addToCart(b.getAttribute('data-variant'), +(b.getAttribute('data-qty') || 1), b.getAttribute('data-shade') || '');
      });
    });

    initPDP();
    initTiers();
  });

  /* ---------- Bundle pack tiers (per-unit shade rows, multi-add) ---------- */
  function initTiers() {
    var root = document.querySelector('.bx-tiers'); if (!root) return;
    var T = (B.tiers) || { shades: [], variants: {}, display: 'swatch' };
    var addBtn = document.querySelector('.bx-tiers__add');
    var tiers = $$('.bx-tier', root);
    var selected = null;
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

    function shadeButtons(activeName) {
      return T.shades.map(function (s) {
        var on = s.name === activeName ? ' is-active' : '';
        return '<button type="button" class="bx-shade' + on + '" data-shade="' + esc(s.name) + '" data-hex="' + esc(s.hex) + '" title="' + esc(s.name) + '" style="--sw:' + esc(s.hex) + ';background:' + esc(s.hex) + '"><span class="bx-shade__dot"></span><span class="bx-shade__name">' + esc(s.name) + '</span></button>';
      }).join('');
    }
    function renderRows(tier) {
      var units = Math.max(1, parseInt(tier.getAttribute('data-units'), 10) || 1);
      var box = tier.querySelector('.bx-tier__shades');
      var first = (T.shades[0] && T.shades[0].name) || '';
      var html = '<div class="bx-tier__shhead">' + esc(T.shadeHeading || 'Scegli la tonalità') + '</div>';
      for (var u = 1; u <= units; u++) {
        html += '<div class="bx-tier__row" data-row="' + u + '">' +
                  (units > 1 ? '<span class="bx-tier__rown">#' + u + '</span>' : '') +
                  '<div class="bx-pdp__shades bx-shades--' + (T.display || 'swatch') + '">' + shadeButtons(first) + '</div></div>';
      }
      box.innerHTML = html; box.hidden = false;
      $$('.bx-tier__row', box).forEach(function (row) {
        $$('.bx-shade', row).forEach(function (b) {
          b.addEventListener('click', function () {
            $$('.bx-shade', row).forEach(function (x) { x.classList.remove('is-active'); });
            b.classList.add('is-active');
          });
        });
      });
    }
    function selectTier(tier) {
      tiers.forEach(function (t) {
        t.classList.remove('is-selected');
        var box = t.querySelector('.bx-tier__shades'); if (box) { box.hidden = true; box.innerHTML = ''; }
      });
      tier.classList.add('is-selected'); renderRows(tier); selected = tier;
    }
    tiers.forEach(function (t) {
      var head = t.querySelector('.bx-tier__head');
      if (head) head.addEventListener('click', function () { selectTier(t); });
    });
    if (addBtn) addBtn.addEventListener('click', function () {
      if (!selected) { selectTier(tiers[0]); return; }
      var items = [];
      $$('.bx-tier__row', selected).forEach(function (row) {
        var active = row.querySelector('.bx-shade.is-active');
        var shade = active && active.getAttribute('data-shade');
        var vid = shade && T.variants[shade];
        if (vid) items.push({ id: vid, quantity: 1 });
      });
      addItems(items, (T.productTitle || 'Confezione') + ' aggiunto al carrello');
    });
    var initial = tiers.filter(function (t) { return t.classList.contains('is-selected'); })[0] || tiers[0];
    if (initial) selectTier(initial);
  }

  /* ---------- Product page (shade + size + sticky bar + gallery) ---------- */
  function initPDP() {
    var pdp = $('#bx-pdp'); if (!pdp) return;
    var data = B.pdp || {};
    var variants = data.variants || [];
    var mode = data.mode || 'demo';
    var hasSize = !!data.hasSize;
    var mf = data.money_format || '€{{amount}}';

    var nowEl = $('#bx-pdp-now'), wasEl = $('#bx-pdp-was'), saveEl = $('#bx-pdp-save'), addEl = $('#bx-pdp-add');
    var shadeLabel = $('#bx-shade-label');
    var stSw = $('#bx-sticky-sw'), stShade = $('#bx-sticky-shade'), stPrice = $('#bx-sticky-price'), stSave = $('#bx-sticky-save');

    var shadeBtns = $$('.bx-shade', pdp);
    var sizeBtns = $$('.bx-size', pdp);
    var swWrap = $('#bx-shade-swatches');
    var showCode = !!(swWrap && swWrap.getAttribute('data-show-code') === '1');
    var state = { shade: null, idx: 1, code: null, hex: null, size: null, sizeBtn: null };

    // initial shade = the active one, else first
    var aShade = shadeBtns.filter(function (b) { return b.classList.contains('is-active'); })[0] || shadeBtns[0];
    shadeBtns.forEach(function (b) { b.classList.remove('is-active'); });
    if (aShade) {
      aShade.classList.add('is-active');
      state.shade = aShade.getAttribute('data-shade'); state.idx = +aShade.getAttribute('data-idx') || 1;
      state.code = aShade.getAttribute('data-code'); state.hex = aShade.getAttribute('data-hex');
    }

    // initial size = the popular/active one, else first
    var aSize = sizeBtns.filter(function (b) { return b.classList.contains('is-active'); })[0] || sizeBtns[0];
    sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
    if (aSize) { aSize.classList.add('is-active'); state.sizeBtn = aSize; state.size = aSize.getAttribute('data-size'); }

    function moneyC(cents) {
      return mf.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
               .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
               .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, (cents / 100).toFixed(2).replace('.', ','));
    }
    function euros(n) { return '€' + (Math.round(n * 100) / 100).toFixed(2); }
    function pct(now, was) { return was > now ? Math.round((1 - now / was) * 100) : 0; }

    // resolve the variant for the current shade (+ size, in product mode)
    function currentVariant() {
      if (!variants.length) return null;
      var both = variants.filter(function (v) { return v.shade === state.shade && (!hasSize || v.size === state.size); });
      if (both.length) return both[0];
      var byShade = variants.filter(function (v) { return v.shade === state.shade; });
      return byShade[0] || null;
    }

    function refresh() {
      if (mode === 'product') {
        var v = currentVariant();
        if (v) {
          nowEl.textContent = moneyC(v.price);
          if (v.cap > v.price) {
            wasEl.textContent = moneyC(v.cap); wasEl.style.display = ''; saveEl.style.display = '';
            saveEl.textContent = 'Risparmia ' + pct(v.price, v.cap) + '%';
          } else { wasEl.style.display = 'none'; saveEl.style.display = 'none'; }
          if (addEl) { addEl.disabled = !v.avail; addEl.textContent = v.avail ? ('Aggiungi al carrello — ' + moneyC(v.price)) : 'Esaurito'; }
          if (stPrice) stPrice.textContent = moneyC(v.price);
          if (stSave) stSave.textContent = v.cap > v.price ? ('Risparmia ' + pct(v.price, v.cap) + '%') : '';
        }
      } else {
        // demo mode: price from the active size block's data attributes
        var s = state.sizeBtn;
        if (s) {
          var now = parseFloat(s.getAttribute('data-now')), was = parseFloat(s.getAttribute('data-was'));
          nowEl.textContent = euros(now); wasEl.textContent = euros(was); wasEl.style.display = ''; saveEl.style.display = '';
          saveEl.textContent = 'Risparmia ' + pct(now, was) + '%';
          if (addEl) addEl.textContent = 'Aggiungi al carrello — ' + euros(now);
          if (stPrice) stPrice.textContent = euros(now);
          if (stSave) stSave.textContent = 'Risparmia ' + pct(now, was) + '%';
        }
      }
      var lbl = (state.code || (state.idx + 'N')) + ' · ' + state.shade;
      if (showCode && state.hex) { lbl += ' · ' + state.hex; }
      shadeLabel.textContent = lbl;
      var hex = state.hex || hexOf(state.shade);
      if (stSw) stSw.style.background = hex;
      if (stShade) stShade.textContent = state.shade;
    }

    shadeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        shadeBtns.forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.shade = btn.getAttribute('data-shade');
        state.idx = +btn.getAttribute('data-idx') || 1;
        state.code = btn.getAttribute('data-code'); state.hex = btn.getAttribute('data-hex');
        refresh();
      });
    });
    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active'); state.sizeBtn = btn; state.size = btn.getAttribute('data-size'); refresh();
      });
    });

    function pdpAdd() {
      var vid = null;
      if (mode === 'product') {
        var v = currentVariant();
        if (v) { if (!v.avail) { toast('Questa tonalità + formato è esaurita'); return; } vid = v.id; }
      } else {
        vid = state.sizeBtn && state.sizeBtn.getAttribute('data-variant');
        if (!vid) { var m = variants.filter(function (v) { return v.shade === state.shade; })[0]; if (m) vid = m.id; }
      }
      addToCart(vid, 1, state.shade);
    }
    if (addEl) addEl.addEventListener('click', pdpAdd);
    $('#bx-sticky-add') && $('#bx-sticky-add').addEventListener('click', pdpAdd);

    // Gallery thumbs
    var main = $('#bx-gallery-main img');
    $$('.bx-pdp__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src') || (t.querySelector('img') && t.querySelector('img').src);
        if (src && main) main.src = src;
      });
    });

    // Sticky bar reveals after the buy box scrolls out
    var bar = $('#bx-stickybar');
    var anchor = addEl || $('.bx-tiers__add');
    if (bar && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        bar.classList.toggle('is-show', !e[0].isIntersecting);
      }, { rootMargin: '-120px 0px 0px 0px' });
      io.observe(anchor);
    }
    refresh();
  }

  /* Run the locale fixup immediately too (this script is at end of <body>, so
     the header/announcement are already parsed) to minimise any flash of the
     overridden English text before DOMContentLoaded fires. */
  try { initLocaleFix(); } catch (e) {}
})();
